import { useEffect } from "react";
import { toast } from "sonner";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { removeToast, toastSelector } from "@/features/toastSlice";
export default function GlobalToaster() {
    const dispatch = useAppDispatch();
    const toasts = useAppSelector(toastSelector);
    useEffect(() => {
        toasts.forEach((t) => {
            if (t.variant === "error") {
                toast.error(t.title, {
                    description: t.description || "Oops! Ein Fehler ist aufgetreten.",
                    duration: 8000,
                });
            }
            if (t.variant === "success") {
                toast.success(t.title, {
                    description: t.description,
                    duration: 5000,
                });
            }
            dispatch(removeToast(t.id));
        });
    }, [toasts, dispatch]);
    return null;
}
